import { createAsyncThunk } from "@reduxjs/toolkit";

import { getCurrentMagentoClient, type OrderPrices } from "@jti/magento";
import type { ApiMagentoPaymentMethod, ApiMagentoPrice, MagentoCustomerCartPrices } from "@jti/magento-types";

type GetCartPricesFunction = (cartId: string) => {
  prices: OrderPrices;
  available_payment_methods: ApiMagentoPaymentMethod[];
  minimum_payable_amount: ApiMagentoPrice;
};

type GetCartPricesResponseType = ReturnType<GetCartPricesFunction>;

export const fetchCartPrices = createAsyncThunk<GetCartPricesResponseType, string>(
  "cart/fetchCartPrices",
  async (cartId: string) => getCurrentMagentoClient(false).getCartPrices(cartId)
);
export const fetchTrialCartPrices = createAsyncThunk<MagentoCustomerCartPrices, string>(
  "freeTrialCart/fetchCartPrices",
  async (cartId: string) => getCurrentMagentoClient(true).getCustomerCartPrices(cartId)
);
